module.exports = __webpack_public_path__ + "img/txl.ce527a9c.svg";